var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54688 14.875C9.30078 14.875 9.125 14.6992 9.125 14.4531V6.85938C9.125 6.64844 9.30078 6.4375 9.54688 6.4375H10.3906C10.6016 6.4375 10.8125 6.64844 10.8125 6.85938V14.4531C10.8125 14.6992 10.6016 14.875 10.3906 14.875H9.54688ZM15.3125 3.0625C15.5938 3.0625 15.875 3.34375 15.875 3.625V4.1875C15.875 4.50391 15.5938 4.75 15.3125 4.75H14.75V16.5625C14.75 17.5117 13.9766 18.25 13.0625 18.25H2.9375C1.98828 18.25 1.25 17.5117 1.25 16.5625V4.75H0.6875C0.371094 4.75 0.125 4.50391 0.125 4.1875V3.625C0.125 3.34375 0.371094 3.0625 0.6875 3.0625H3.57031L4.76562 1.09375C5.04688 0.601562 5.60938 0.25 6.20703 0.25H9.75781C10.3555 0.25 10.918 0.601562 11.1992 1.09375L12.3945 3.0625H15.3125ZM6.13672 2.04297L5.53906 3.0625H10.4258L9.82812 2.04297C9.79297 2.00781 9.72266 1.9375 9.65234 1.9375H6.34766C6.3125 1.9375 6.3125 1.9375 6.3125 1.9375C6.24219 1.9375 6.17188 2.00781 6.13672 2.04297ZM13.0625 16.5625V4.75H2.9375V16.5625H13.0625ZM5.60938 14.875C5.36328 14.875 5.1875 14.6992 5.1875 14.4531V6.85938C5.1875 6.64844 5.36328 6.4375 5.60938 6.4375H6.45312C6.66406 6.4375 6.875 6.64844 6.875 6.85938V14.4531C6.875 14.6992 6.66406 14.875 6.45312 14.875H5.60938Z",
    fill: "#2C2C2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlack);
export default __webpack_public_path__ + "static/media/delete-black.695026043eb6bc474c6e5eca1e63e7e7.svg";
export { ForwardRef as ReactComponent };